/**
 * Internal event bus events for announcements
 * These are NOT analytics events - they're for component communication
 */
export enum AnnouncementActionEvent {
	OpenAnnouncement = 'open-announcement',
}

export interface OpenAnnouncementEvent {
	id?: string;
}
